var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.513 4.487L8.687 11.24l-.88-2.28-.214-.553-.546-.214-2.287-.886 6.753-2.82zM14 2L2 7.02v.653L6.56 9.44 8.32 14h.653L14 2z",
    fill: "var(--icon-dark-gray)"
  })));
}
export default SvgNavigate;